import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Inline, type InlineProps } from '@atlaskit/primitives/compiled';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { token } from '@atlaskit/tokens';

const knowledgeCardStyles = cssMap({
	default: {
		borderRadius: token('radius.small'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
	},
	compact: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingLeft: token('space.150'),
		paddingBottom: token('space.150'),
	},
	full: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingLeft: token('space.200'),
		paddingBottom: token('space.200'),
	},
});

const defaultInlineProps = {
	alignBlock: 'center' as const,
	grow: 'fill' as const,
	space: 'space.050' as const,
};

type KnowledgeCardProps = {
	name: string;
	size: 'full' | 'compact';
	containerStyles?: InlineProps['xcss'];
} & InlineProps;

export const KnowledgeCard = ({
	name,
	size,
	children,
	containerStyles,
	...inlineProps
}: KnowledgeCardProps) => {
	const knowledgeCardProps = {
		...defaultInlineProps,
		...inlineProps,
	};

	return (
		<UFOSegment name={name}>
			<Box as="section">
				<Inline
					{...knowledgeCardProps}
					xcss={
						containerStyles ??
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
						cx(
							knowledgeCardStyles.default,
							size === 'full' ? knowledgeCardStyles.full : knowledgeCardStyles.compact,
						)
					}
				>
					{children}
				</Inline>
			</Box>
		</UFOSegment>
	);
};
